import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkOperationsPanel = ({ routes, onApplyTemplate, onDuplicate, onExport, onImport }) => {
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [selectedSourceRoute, setSelectedSourceRoute] = useState('');
  const [selectedTargetRoutes, setSelectedTargetRoutes] = useState([]);

  const templates = [
    { value: 'weekday_standard', label: 'Hafta İçi Standart (06:00-22:00, 15dk)' },
    { value: 'weekend_standard', label: 'Hafta Sonu Standart (08:00-20:00, 20dk)' },
    { value: 'peak_hours', label: 'Yoğun Saatler (07:00-09:00, 17:00-19:00, 10dk)' },
    { value: 'night_service', label: 'Gece Servisi (22:00-06:00, 30dk)' }
  ];

  const handleApplyTemplate = () => {
    if (selectedTemplate && selectedTargetRoutes?.length > 0) {
      onApplyTemplate(selectedTemplate, selectedTargetRoutes);
      setSelectedTemplate('');
      setSelectedTargetRoutes([]);
    }
  };

  const handleDuplicate = () => {
    if (selectedSourceRoute && selectedTargetRoutes?.length > 0) {
      onDuplicate(selectedSourceRoute, selectedTargetRoutes);
      setSelectedSourceRoute('');
      setSelectedTargetRoutes([]);
    }
  };

  const handleFileImport = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const data = JSON.parse(event?.target?.result);
          onImport(data);
        } catch (error) {
          console.error('Dosya okuma hatası:', error);
        }
      };
      reader?.readAsText(file);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 space-y-6">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Layers" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-semibold text-foreground font-heading">
          Toplu İşlemler
        </h3>
      </div>
      <div className="space-y-6">
        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h4 className="text-sm font-semibold text-foreground">Şablon Uygula</h4>
          <Select
            label="Şablon Seç"
            options={templates}
            value={selectedTemplate}
            onChange={setSelectedTemplate}
            placeholder="Şablon seçiniz"
          />
          <Select
            label="Hedef Rotalar"
            options={routes?.map(route => ({
              value: route?.id,
              label: route?.route_name
            }))}
            value={selectedTargetRoutes}
            onChange={setSelectedTargetRoutes}
            multiple
            searchable
            placeholder="Rota seçiniz"
          />
          <Button
            variant="default"
            fullWidth
            onClick={handleApplyTemplate}
            disabled={!selectedTemplate || selectedTargetRoutes?.length === 0}
            iconName="CheckCircle"
            iconPosition="left"
          >
            Şablonu Uygula
          </Button>
        </div>

        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h4 className="text-sm font-semibold text-foreground">Program Kopyala</h4>
          <Select
            label="Kaynak Rota"
            options={routes?.map(route => ({
              value: route?.id,
              label: route?.route_name
            }))}
            value={selectedSourceRoute}
            onChange={setSelectedSourceRoute}
            searchable
            placeholder="Kaynak rota seçiniz"
          />
          <Select
            label="Hedef Rotalar"
            options={routes?.filter(r => r?.id !== selectedSourceRoute)?.map(route => ({
              value: route?.id,
              label: route?.route_name
            }))}
            value={selectedTargetRoutes}
            onChange={setSelectedTargetRoutes}
            multiple
            searchable
            placeholder="Hedef rotalar seçiniz"
          />
          <Button
            variant="secondary"
            fullWidth
            onClick={handleDuplicate}
            disabled={!selectedSourceRoute || selectedTargetRoutes?.length === 0}
            iconName="Copy"
            iconPosition="left"
          >
            Programı Kopyala
          </Button>
        </div>

        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h4 className="text-sm font-semibold text-foreground">İçe/Dışa Aktar</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Button
              variant="outline"
              fullWidth
              onClick={onExport}
              iconName="Download"
              iconPosition="left"
            >
              Dışa Aktar
            </Button>
            <label className="block">
              <input
                type="file"
                accept=".json"
                onChange={handleFileImport}
                className="hidden"
              />
              <Button
                variant="outline"
                fullWidth
                iconName="Upload"
                iconPosition="left"
                asChild
              >
                İçe Aktar
              </Button>
            </label>
          </div>
        </div>
      </div>
      <div className="p-4 bg-warning/10 border border-warning rounded-lg">
        <div className="flex items-start gap-3">
          <div className="flex items-center justify-center w-6 h-6 bg-warning/20 rounded-full flex-shrink-0 mt-0.5">
            <Icon name="AlertTriangle" size={14} color="var(--color-warning)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-foreground">
              Toplu işlemler geri alınamaz. Lütfen işlem yapmadan önce mevcut programlarınızı dışa aktararak yedekleyin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsPanel;